<template>
	<div class="container-fluid">
		<div v-show="errors !== null">
			<save-error
				@close="errors = null"
				:errors="errors"
			/>
		</div>
		<div class="m-2">
			<div class="alert alert-primary h4 text-center">
                <linkto :link="'/'"/>
                Feladat módosítás
    		</div>
		</div>
		<div class="row d-flex justify-content-center">
			<div class="col-12">
				<task-customer
					:task="ugyfel"
					@update="updateTask"
				>
				</task-customer>
			</div>
			<div class="col-10"><hr></div>
		</div>
		<div class="row d-flex justify-content-center align-items-center">
			<div class="col-12 text-center">
				<h5 class="mt-2 mb-2">Feladat részletek</h5>
			</div>
			<div class="col-6 col-md-3">
				<input type="checkbox" v-model="task.aktiv" @change="close">
    			<label class="h5">
    				Állapot
    				<span class="small">
    					({{~~task.aktiv === 0 ? 'nem':''}} aktív)
    				</span>
    			</label>
			</div>
			<div class="col-6 col-md-3">
				<label class="h5">
					Rögzítve
				</label>
				<p>
					{{task.datum}}
				</p>
			</div>
			<div class="col-6 col-md-3">
				<label class="h5">
					Határidő
				</label>
				<date-picker
					class="text-center"
					v-model="task.hatarido"
					:config="date_options"
					placeholder="Határidő"
				/>
			</div>
			<div class="col-6 col-md-3">
				<label class="h5">
					Felelős
				</label>
				<select v-model="task.userid" class="form-control">
				  	<option
				  		v-for="(v,k) in users"
				  		:key="k"
				  		:value="v.azon"
				  	>
				  		{{ v.nev }}
				  	</option>
				</select>
			</div>
			<div class="col-12 col-md-6 mt-1">
				<label class="h5">
					Feladat rövid leírása
					<span class="small">még {{ charLeftRovid }} karakter</span>
				</label>
				<textarea
					class="form-control"
					v-model="task.feladat_rovid"
					rows="3"
				/>
			</div>
			<div class="col-12 col-md-6 mt-1">
				<label class="h5">
					Feladat leírása
					<span class="small">még {{ charLeft }} karakter</span>
				</label>
				<textarea
					class="form-control"
					v-model="task.feladat"
					rows="5"
				/>
			</div>
		</div>
		<div class="row d-flex justify-content-center mt-2">
			<button class="btn btn-lg btn-primary m-1" @click.prevent="saveTask">
				Mentés
			</button>
		</div>
	</div>
</template>
<script type="text/javascript">
import taskCustomer from '@/components/tasks/taskCustomer'
export default {
	components: {
		taskCustomer
	},

	data () {
		return {
			id: '',
			task: {},
			ugyfel: {},
			users: [],
			errors: null,
			nowClosed: false
		}
	},

	created() {
		this.id = this.$route.params.id
		this.init()
	},

	methods: {
		init() {
			this.getUsers()
			this.getTask()
			this.errors = null
		},

		updateTask(val) {
			this.task.uszam = val.uszam
			this.saveTask()
		},

		getUsers() {
			this.$Progress.start()
	      	this.isLoading = true
	      	this.req.get(`/tasks/getusers`)
	          	.then(res => {
	          		if(res.data.status === `error`) {
	          			this.$Progress.fail()
	              		this.isLoading = false
	              		toastr.error(res.data.text)
	          		} else {
	          			this.users = res.data.users
		              	this.$Progress.finish()
		              	this.isLoading = false
		              	//this.init()
	          		}
	          	})
	          	.catch(err => {
	              	this.$Progress.fail()
	              	this.isLoading = false
	              	toastr.error(err)
	          	})
		},

		getTask() {
			console.log('ffff')
			this.$Progress.start()
	      	this.isLoading = true
	      	this.req.post(`/tasks/gettask`, {
	      		id: this.id
	      	})
	          	.then(res => {
	          		if(res.data.status === `error`) {
	          			this.$Progress.fail()
	              		this.isLoading = false
	              		toastr.error(res.data.text)
	              		return
	          		}
	              	this.task = res.data.task[0]
	              	this.ugyfel = res.data.ugyfel[0]
	              	this.$Progress.finish()
	              	this.isLoading = false
	          	})
	          	.catch(err => {
	              	this.$Progress.fail()
	              	this.isLoading = false
	              	toastr.error(err)
	          	})
		},

		saveTask() {
			this.$Progress.start()
	      	this.isLoading = true
	      	this.req.post(`/tasks/savetask`, this.task)
	          	.then(res => {
	          		if(res.data.status === `error`) {
	          			this.$Progress.fail()
	              		this.isLoading = false
	              		toastr.error(res.data.text)
	          		} else {
	          			toastr.success(res.data.text)
		              	this.$Progress.finish()
		              	this.isLoading = false
	          		}
	          	})
	          	.catch(err => {
	              	this.$Progress.fail()
	              	this.isLoading = false
	              	toastr.error(err)
	          	})
		},

		close() {
			if(!this.task.aktiv) {
				this.task.zardatum = this.$moment().format('YYYY-MM-DD')
			} else {
				this.task.modositas_datum = this.task.zardatum
				this.task.zardatum = null
			}
		}
	},

	computed: {
		charLeftRovid() {
			let char = this.task.feladat_rovid !== undefined ? this.task.feladat_rovid.length : 0
			return 100 - ~~char
		},

		charLeft() {
			let char = this.task.feladat !== undefined ? this.task.feladat.length : 0
			return 3000 - ~~char
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/tasks/editTask.vue